import { Outlet, useOutletContext, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import Loader from "../loader";
import { init as initDesignState } from "../../features/designSlice";
import { DESIGN_QUERY_KEY } from "../../queries-keys/designs";
import { ITEM_LAYOUTS_QUERY_KEY } from "../../queries-keys/items";
import { getItemLayouts } from "../../apis/itemsApi";
import Design from "../../models/Design";
import LayoutBody from "../../models/furniture/LayoutBody";
import LayoutSize from "../../models/furniture/LayoutSize";
import { getDesign } from "../../apis/designsApi";

interface OutletContextType {
  sessionRemainingTime?: number;
}

function GetDesign() {
  const dispatch = useDispatch();
  const { designId } = useParams<{ designId: string }>();
  const { sessionRemainingTime } = useOutletContext<OutletContextType>() || {};

  const {
    data: design,
    isLoading: isLoadingDesign,
    isFetching: isFetchingDesign,
  } = useQuery<Design>(
    DESIGN_QUERY_KEY(designId),
    () => getDesign(Number(designId)),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      enabled: !!designId,
      onSuccess: (design) => {
        dispatch(initDesignState({ ...design }));
      },
    }
  );

  const {
    data: layouts,
    isLoading: isFetchingItemLayouts,
    isIdle,
  } = useQuery<{ bodyLayouts: LayoutBody[]; sizeLayouts: LayoutSize[] }>(
    ITEM_LAYOUTS_QUERY_KEY(
      design?.item && typeof design.item !== "number"
        ? design.item.id
        : undefined
    ),
    () =>
      getItemLayouts(
        typeof design?.item === "number" ? design.item : design?.item?.id || 0
      ),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled:
        !!design?.item &&
        (typeof design.item === "number" || !!design.item?.id),
    }
  );

  //TODO: handle error

  return (
    <>
      {isFetchingDesign ||
      isFetchingItemLayouts ||
      isIdle ||
      isLoadingDesign ? (
        <Loader className="min-h-[400px]" />
      ) : (
        <Outlet
          context={{
            sessionRemainingTime,
            item: design?.item,
            layouts,
          }}
        />
      )}
    </>
  );
}

export default GetDesign;
